import { API } from "../axios/API";

export const grupoEtapasService = {
  getGrupoEtapas
};

async function getGrupoEtapas() {
  // return arrayData;
  try {
    const resp = await API.get("/grupo-etapas");
    return resp?.data;
  } catch (err) {
    console.log(err);
    return err.response;
  }
}